import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FichierPro.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const statutLabels = {
  nouveau: 'Nouveau', contacte: 'Contacté', rappel: 'À rappeler', interesse: 'Intéressé',
  rdv_pris: 'RDV pris', negociation: 'Négociation', converti: 'Converti',
  pas_interesse: 'Pas intéressé', nrp: 'NRP', faux_num: 'Faux numéro', perdu: 'Perdu'
};

const isPdf = (u) => /\.pdf$/i.test(u || '');
const isImage = (u) => /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(u || '');

const FICHE_LABELS = {
  raison_sociale: 'Raison sociale', siret: 'SIRET', gerant: 'Gérant',
  adresse: 'Adresse', code_postal: 'Code postal', ville: 'Ville',
  tel_fixe: 'Téléphone fixe', tel_mobile: 'Téléphone mobile', secteur: "Secteur d'activité",
  individuel: 'En individuel', jour_repos: 'Jour de fermeture/repos', proprietaire: 'Propriétaire du fonds',
  etude_batterie: 'Étude batterie condensateur', presence_batterie: 'Présence batterie condensateur',
  age_activite: "Âge d'activité", facture_elec: "Facture d'électricité", frequence_paiement: 'Fréquence de paiement',
  eclairage_leds: 'Éclairage LED', commentaire: 'Commentaire', rdv: 'Rendez-vous', telepro: 'Télépro'
};
const FICHE_ORDER = ['rdv', 'telepro', 'raison_sociale', 'siret', 'gerant', 'proprietaire', 'adresse', 'code_postal', 'ville', 'tel_fixe', 'tel_mobile', 'secteur', 'individuel', 'jour_repos', 'age_activite', 'facture_elec', 'frequence_paiement', 'etude_batterie', 'presence_batterie', 'eclairage_leds', 'commentaire'];
const parseFiche = (raw) => { if (!raw) return null; try { return typeof raw === 'string' ? JSON.parse(raw) : raw; } catch (e) { return null; } };

function LeadsCEEAdmin() {
  const [leads, setLeads] = useState([]);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ nom: '', entreprise: '', telephone: '', email: '', message: '', agent_id: '' });
  const [file, setFile] = useState(null);
  const [fiche, setFiche] = useState(null);
  const [selected, setSelected] = useState([]);
  const [bulkAgent, setBulkAgent] = useState('');
  const [bulkBusy, setBulkBusy] = useState(false);
  const [filterActivite, setFilterActivite] = useState('tous');

  const token = () => localStorage.getItem('token');

  const toggleSelect = (id) => setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

  const handleBulkAssign = async () => {
    if (!selected.length) { alert('Sélectionnez au moins un lead'); return; }
    setBulkBusy(true);
    try {
      for (const id of selected) {
        await axios.patch(`${API_URL}/api/leads/${id}/assigner`, { agent_id: bulkAgent || null }, {
          headers: { Authorization: `Bearer ${token()}` }
        });
      }
      setSelected([]);
      await fetchLeads();
    } catch (err) {
      alert(err.response?.data?.error || 'Erreur lors de l\'attribution groupée');
    } finally {
      setBulkBusy(false);
    }
  };

  const fetchLeads = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/leads?type=cee`, { headers: { Authorization: `Bearer ${token()}` } });
      setLeads(res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur chargement leads');
    } finally {
      setLoading(false);
    }
  };

  const fetchAgents = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/users`, { headers: { Authorization: `Bearer ${token()}` } });
      setAgents((res.data || []).filter(u => u.role === 'agent' && u.is_agent_cee));
    } catch (err) {
      console.error('Erreur chargement agents CEE', err);
    }
  };

  useEffect(() => { fetchLeads(); fetchAgents(); /* eslint-disable-next-line */ }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nom.trim()) { setError('Le nom est requis'); return; }
    setSaving(true); setError('');
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => { if (v) fd.append(k, v); });
      if (file) fd.append('fichier', file);
      await axios.post(`${API_URL}/api/leads-cee`, fd, {
        headers: { Authorization: `Bearer ${token()}`, 'Content-Type': 'multipart/form-data' }
      });
      setForm({ nom: '', entreprise: '', telephone: '', email: '', message: '', agent_id: '' });
      setFile(null);
      const fileInput = document.getElementById('lead-cee-file');
      if (fileInput) fileInput.value = '';
      fetchLeads();
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la création du lead');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce lead CEE ?')) return;
    try {
      await axios.delete(`${API_URL}/api/leads/${id}`, { headers: { Authorization: `Bearer ${token()}` } });
      setLeads(prev => prev.filter(l => l.id !== id));
    } catch (err) {
      alert(err.response?.data?.error || 'Erreur suppression');
    }
  };

  const handleAssign = async (id, agent_id) => {
    try {
      await axios.patch(`${API_URL}/api/leads/${id}/assigner`, { agent_id: agent_id || null }, {
        headers: { Authorization: `Bearer ${token()}` }
      });
      fetchLeads();
    } catch (err) {
      alert(err.response?.data?.error || 'Erreur assignation');
    }
  };

  const activites = [...new Set(leads.map(l => l.activite).filter(Boolean))].sort();
  const displayed = filterActivite === 'tous' ? leads : leads.filter(l => l.activite === filterActivite);

  return (
    <div className="fichier-pro">
      <div className="fichier-pro-header">
        <h2>Leads CEE — Administration</h2>
        <p className="fichier-pro-subtitle">Créez des leads CEE (visibles par vous, admin) puis attribuez-les aux agents CEE | <strong>{leads.length}</strong> lead{leads.length !== 1 ? 's' : ''}</p>
      </div>

      {/* Formulaire de création */}
      <form className="fichier-pro-filters" onSubmit={handleSubmit} style={{ alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div className="filter-group">
          <label>Nom *</label>
          <input className="filter-input" value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} placeholder="Nom du contact / société" required />
        </div>
        <div className="filter-group">
          <label>Entreprise</label>
          <input className="filter-input" value={form.entreprise} onChange={e => setForm({ ...form, entreprise: e.target.value })} placeholder="Entreprise" />
        </div>
        <div className="filter-group">
          <label>Téléphone</label>
          <input className="filter-input" value={form.telephone} onChange={e => setForm({ ...form, telephone: e.target.value })} placeholder="Téléphone" />
        </div>
        <div className="filter-group">
          <label>Email</label>
          <input className="filter-input" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="Email" />
        </div>
        <div className="filter-group">
          <label>Assigner à (agent CEE)</label>
          <select value={form.agent_id} onChange={e => setForm({ ...form, agent_id: e.target.value })}>
            <option value="">— Non assigné (visible admin uniquement) —</option>
            {agents.map(a => <option key={a.id} value={a.id}>{a.nom}</option>)}
          </select>
        </div>
        <div className="filter-group" style={{ minWidth: '260px' }}>
          <label>Note / message</label>
          <input className="filter-input" value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="Infos du lead" />
        </div>
        <div className="filter-group">
          <label>Photo ou PDF</label>
          <input id="lead-cee-file" type="file" accept="image/*,application/pdf" onChange={e => setFile(e.target.files[0] || null)} />
        </div>
        <button className="btn-search" type="submit" disabled={saving}>
          {saving ? <><span className="spinner-small"></span> Ajout...</> : '+ Ajouter le lead'}
        </button>
      </form>

      {error && <div className="fichier-pro-error">{error}</div>}

      {/* Attribution groupée */}
      {selected.length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', background: '#f3f0ff', border: '1px solid #d6c9ff', borderRadius: '8px', padding: '10px 14px', margin: '8px 0' }}>
          <strong>{selected.length} lead{selected.length > 1 ? 's' : ''} sélectionné{selected.length > 1 ? 's' : ''}</strong>
          <span>→ attribuer à :</span>
          <select value={bulkAgent} onChange={e => setBulkAgent(e.target.value)}>
            <option value="">— Désassigner (visible admin uniquement) —</option>
            {agents.map(a => <option key={a.id} value={a.id}>{a.nom}</option>)}
          </select>
          <button className="btn-search" onClick={handleBulkAssign} disabled={bulkBusy}>
            {bulkBusy ? <><span className="spinner-small"></span> Attribution...</> : 'Attribuer'}
          </button>
          <button className="btn-voir-fiche" style={{ background: '#888' }} onClick={() => setSelected([])}>Désélectionner</button>
        </div>
      )}

      {!loading && (
        <div className="fichier-pro-results">
          <div className="fichier-pro-filters" style={{ marginBottom: '12px' }}>
            <div className="filter-group">
              <label>Filtrer par activité</label>
              <select value={filterActivite} onChange={e => setFilterActivite(e.target.value)}>
                <option value="tous">-- Toutes --</option>
                {activites.map(a => <option key={a} value={a}>{a}</option>)}
              </select>
            </div>
            <span className="results-count" style={{ alignSelf: 'center' }}>{displayed.length} lead{displayed.length !== 1 ? 's' : ''}{filterActivite !== 'tous' ? ` · ${filterActivite}` : ''}</span>
          </div>
          {displayed.length > 0 ? (
            <div className="table-wrapper">
              <table className="fichier-pro-table">
                <thead>
                  <tr>
                    <th><input type="checkbox" checked={selected.length === displayed.length && displayed.length > 0} onChange={() => setSelected(prev => prev.length === displayed.length ? [] : displayed.map(l => l.id))} title="Tout sélectionner" /></th>
                    <th>Nom</th>
                    <th>Entreprise</th>
                    <th>Téléphone</th>
                    <th>Activité</th>
                    <th>Document</th>
                    <th>Assigné à</th>
                    <th>Statut</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {displayed.map(l => (
                    <tr key={l.id} style={selected.includes(l.id) ? { background: '#f3f0ff' } : undefined}>
                      <td><input type="checkbox" checked={selected.includes(l.id)} onChange={() => toggleSelect(l.id)} /></td>
                      <td className="td-nom">{l.nom}</td>
                      <td>{l.entreprise || '-'}</td>
                      <td className="td-phone">{l.telephone || '-'}</td>
                      <td>{l.activite ? <span style={{ display: 'inline-block', padding: '3px 9px', borderRadius: '12px', background: '#eef2ff', color: '#4338ca', fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap' }}>{l.activite}</span> : <span style={{ color: '#bbb' }}>—</span>}</td>
                      <td>
                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                          {parseFiche(l.fiche_data) && (
                            <button className="btn-voir-fiche" style={{ background: '#7b2ff7', color: '#fff' }}
                              onClick={() => setFiche({ data: parseFiche(l.fiche_data), nom: l.nom, fichier_url: l.fichier_url })}>
                              📋 Fiche
                            </button>
                          )}
                          {l.fichier_url && (
                            <a className="btn-voir-fiche" style={{ textDecoration: 'none' }} href={`${API_URL}${l.fichier_url}`} target="_blank" rel="noopener noreferrer">
                              {isPdf(l.fichier_url) ? '📄 PDF' : isImage(l.fichier_url) ? '🖼️ Photo' : '📎 Doc'}
                            </a>
                          )}
                          {!parseFiche(l.fiche_data) && !l.fichier_url && <span style={{ color: '#bbb' }}>—</span>}
                        </div>
                      </td>
                      <td>
                        <select value={l.agent_id || ''} onChange={e => handleAssign(l.id, e.target.value)}>
                          <option value="">— Non assigné (admin) —</option>
                          {agents.map(a => <option key={a.id} value={a.id}>{a.nom}</option>)}
                        </select>
                      </td>
                      <td>{statutLabels[l.statut] || l.statut}</td>
                      <td><button className="btn-voir-fiche" style={{ background: '#c0392b' }} onClick={() => handleDelete(l.id)}>Supprimer</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="no-results">Aucun lead CEE. Ajoutez-en un avec le formulaire ci-dessus.</div>
          )}
        </div>
      )}

      {/* Fiche CEE structurée */}
      {fiche && (
        <div className="modal-overlay" onClick={() => setFiche(null)}>
          <div className="modal-content planning-modal" style={{ maxWidth: '720px', width: '92vw', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3 style={{ margin: 0 }}>📋 Fiche CEE — {fiche.nom}</h3>
              <button className="btn-close" onClick={() => setFiche(null)}>&times;</button>
            </div>
            <div className="fiche-detail-body" style={{ padding: '6px 4px' }}>
              {FICHE_ORDER.filter(k => fiche.data[k]).map(k => (
                <div className="fiche-detail-row" key={k}>
                  <span className="fiche-label">{FICHE_LABELS[k] || k}</span>
                  <span className="fiche-value">{fiche.data[k]}</span>
                </div>
              ))}
              {fiche.data.texte_complet && (
                <div style={{ marginTop: '14px' }}>
                  <div className="fiche-label" style={{ marginBottom: '6px' }}>Contenu complet du document</div>
                  <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'inherit', fontSize: '13px', lineHeight: 1.5, background: '#f7f7fa', border: '1px solid #e3e3ef', borderRadius: '8px', padding: '12px', margin: 0, color: '#333' }}>
                    {fiche.data.texte_complet}
                  </pre>
                </div>
              )}
              {fiche.fichier_url && (
                <div className="fiche-detail-actions" style={{ marginTop: '12px' }}>
                  <a className="btn-search" style={{ textDecoration: 'none', display: 'inline-block' }}
                     href={`${API_URL}${fiche.fichier_url}`} target="_blank" rel="noopener noreferrer">
                    Ouvrir le document d'origine
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LeadsCEEAdmin;
